import React, { useEffect, useState } from "react";
import "../../styles/UserForm.css";
import { rm_update } from "../../services/roleMasterService";

export default function EditRole({
  roleData,
  onClose,
  onSuccess,
}) {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const [form, setForm] = useState({
    name: "",
    code: "",
    description: "",
    status: "Active",
  });

  useEffect(() => {
    if (roleData) {
      setForm({
        name: roleData.name,
        code: roleData.code,
        description: roleData.description || "",
        status: roleData.status || "Active",
      });
    }
  }, [roleData]);

  const update = (k, v) =>
    setForm((p) => ({ ...p, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    try {
      setSaving(true);
      const res = await rm_update(roleData.id, form);
      if (res?.data?.success) {
        onSuccess();
        onClose();
      } else {
        setError(res?.data?.message || "Failed to update");
      }
    } finally {
      setSaving(false);
    }
  };

  if (!roleData) return null;

  return (
    <div className="uf-modal" onClick={onClose}>
      <div
        className="uf-card"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="uf-header">
          <h5 className="text-white">Edit Role</h5>
          <button onClick={onClose}>✕</button>
        </div>

        <form onSubmit={submit}>
          <div className="uf-body">
            {error && (
              <div className="alert alert-danger py-2">
                {error}
              </div>
            )}
            <div className="uf-grid">
              <div>
                <label className="form-label">Name</label>
                <input
                  className="form-control"
                  value={form.name}
                  onChange={(e) => update("name", e.target.value)}
                />
              </div>
              <div>
                <label className="form-label">
                  Code (read only)
                </label>
                <input
                  className="form-control"
                  value={form.code}
                  disabled
                  readOnly
                />
              </div>
              <div>
                <label className="form-label">
                  Description
                </label>
                <input
                  className="form-control"
                  value={form.description}
                  onChange={(e) =>
                    update("description", e.target.value)
                  }
                />
              </div>

              <div className="form-check form-switch mt-4">
                <input
                  type="checkbox"
                  className="form-check-input"
                  checked={form.status === "Active"}
                  onChange={(e) =>
                    update(
                      "status",
                      e.target.checked ? "Active" : "Inactive"
                    )
                  }
                />
                <label className="form-check-label">
                  Active (toggle to Inactive)
                </label>
              </div>
            </div>
          </div>

          <div className="uf-actions">
            <button
              type="button"
              className="btn btn-cancel"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary"
              type="submit"
              disabled={saving}
            >
              {saving ? "Saving…" : "Update Role"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
